import React from 'react';

var Delete = function Delete(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 6l.001-1.51h.147a3.49 3.49 0 0 1 3.342-2.488L12.505 2a3.49 3.49 0 0 1 3.49 3.49v.065L15.987 6H20a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2h4zm2.002 0h3.984v-.019l.01-.463V5.49A1.49 1.49 0 0 0 12.506 4l-1.015.002a1.49 1.49 0 0 0-1.49 1.489V6zM8.5 11a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm5 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm-9.447-.008a1 1 0 1 1 2 .016l-.055 7.094A1.886 1.886 0 0 0 7.88 20h8.237c1.04 0 1.883-.843 1.883-1.892l-.032-7.103a1 1 0 1 1 2-.01l.032 7.122A3.883 3.883 0 0 1 16.118 22H7.851a3.883 3.883 0 0 1-3.853-3.913l.055-7.095z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Delete.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Delete as icon };
export default iconHandler(Delete);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Delete.js
// module id = 592
// module chunks = 0